export const summaryPageTopMenu = {
	intro: { id: 'intro', text: 'Intro', path: '#intro', icon: 'Vrpano', subMenu: null },
	bootstrap: {
		id: 'bootstrap',
		text: 'Bootstrap Components',
		path: '#bootstrap',
		icon: 'BootstrapFill',
		subMenu: null,
	},
	storybook: {
		id: 'storybook',
		text: 'Storybook',
		path: '#storybook',
		icon: 'CustomStorybook',
		subMenu: null,
	},
	formik: {
		id: 'formik',
		text: 'Formik',
		path: '#formik',
		icon: 'CheckBox',
		subMenu: null,
	},
	apex: {
		id: 'apex',
		text: 'Apex Charts',
		path: '#apex',
		icon: 'AreaChart',
		subMenu: null,
	},
};

export const dashboardPagesMenu = {
	dashboard: {
		id: 'dashboard',
		text: 'Dashboard',
		path: '/',
		icon: 'Dashboard',
		subMenu: null,
	},
	dashboardProject: {
		id: 'dashboardProject',
		text: 'Dashboard Projects',
		path: 'project-management/list',
		icon: 'AutoStories',
		notification: true,
		subMenu: null,
	},
	dashboardBooking: {
		id: 'dashboard-booking',
		text: 'Dashboard Booking',
		path: 'dashboard-booking',
		icon: 'emoji_transportation',
		subMenu: null,
	},
	crmDashboard: {
		id: 'crmDashboard',
		text: 'CRM Dashboard',
		path: 'crm/dashboard',
		icon: 'RecentActors',
	},
	summary: {
		id: 'summary',
		text: 'Summary',
		path: 'summary',
		icon: 'sticky_note_2',
		subMenu: null,
	},
};

export const demoPagesMenu = {
	pages: {
		id: 'pages',
		text: 'Pages',
		icon: 'Extension',
	},
	listPages: {
		id: 'listPages',
		text: 'List Pages',
		path: 'list-pages',
		icon: 'Dvr',
		subMenu: {
			listBoxed: {
				id: 'listBoxed',
				text: 'Boxed List',
				path: 'list-pages/boxed-list',
				icon: 'ViewArray',
			},
			listFluid: {
				id: 'listFluid',
				text: 'Fluid List',
				path: 'list-pages/fluid-list',
				icon: 'ViewDay',
			},
		},
	},
	gridPages: {
		id: 'gridPages',
		text: 'Grid Pages',
		path: 'grid-pages',
		icon: 'Window',
		subMenu: {
			gridBoxed: {
				id: 'gridBoxed',
				text: 'Boxed Grid',
				path: 'grid-pages/boxed',
				icon: 'ViewArray',
			},
			gridFluid: {
				id: 'gridFluid',
				text: 'Fluid Grid',
				path: 'grid-pages/fluid',
				icon: 'ViewDay',
			},
		},
	},
	editPages: {
		id: 'editPages',
		text: 'Edit Pages',
		path: 'edit-pages',
		icon: 'drive_file_rename_outline ',
		subMenu: {
			editModern: {
				id: 'editModern',
				text: 'Modern Edit',
				path: 'edit-pages/modern',
				icon: 'AutoAwesomeMosaic',
				notification: 'primary',
			},
			editBoxed: {
				id: 'editBoxed',
				text: 'Boxed Edit',
				path: 'edit-pages/boxed',
				icon: 'ViewArray',
			},
			editFluid: {
				id: 'editFluid',
				text: 'Fluid Edit',
				path: 'edit-pages/fluid',
				icon: 'ViewDay',
			},
			editWizard: {
				id: 'editWizard',
				text: 'Wizard Edit',
				path: 'edit-pages/wizard',
				icon: 'LinearScale',
			},
			editInCanvas: {
				id: 'editInCanvas',
				text: 'In Canvas Edit',
				path: 'edit-pages/in-canvas',
				icon: 'VerticalSplit',
			},
			editInModal: {
				id: 'editInModal',
				text: 'In Modal Edit',
				path: 'edit-pages/in-modal',
				icon: 'PictureInPicture',
			},
		},
	},
	singlePages: {
		id: 'singlePages',
		text: 'Single Pages',
		path: 'single-pages',
		icon: 'Article',
		subMenu: {
			boxedSingle: {
				id: 'boxedSingle',
				text: 'Boxed',
				path: 'single-pages/boxed',
				icon: 'ViewArray',
			},
			fluidSingle: {
				id: 'fluidSingle',
				text: 'Fluid',
				path: 'single-pages/fluid',
				icon: 'ViewDay',
			},
		},
	},
	pricingTable: {
		id: 'pricingTable',
		text: 'Pricing Table',
		path: 'pricing-table',
		icon: 'Local Offer',
	},

	app: {
		id: 'app',
		text: 'Apps',
		icon: 'Extension',
	},
	projectManagement: {
		id: 'projectManagement',
		text: 'Project Management',
		path: 'project-management',
		icon: 'AutoStories',
		subMenu: {
			list: {
				id: 'list',
				text: 'Projects',
				path: 'project-management/list',
				icon: 'AutoStories',
			},
			itemID: {
				id: 'projectID',
				text: 'projectID',
				path: 'project-management/project',
				hide: true,
			},
			item: {
				id: 'item',
				text: 'Project',
				path: 'project-management/project/1',
				icon: 'Book',
			},
		},
	},
	knowledge: {
		id: 'knowledge',
		text: 'Knowledge',
		path: 'knowledge',
		icon: 'AutoStories',
		subMenu: {
			grid: {
				id: 'grid',
				text: 'Knowledge Grid',
				path: 'knowledge/grid',
				icon: 'AutoStories',
			},
			itemID: {
				id: 'itemID',
				text: 'itemID',
				path: 'knowledge/item',
				hide: true,
			},
			item: {
				id: 'item',
				text: 'Item',
				path: 'knowledge/item/1',
				icon: 'Book',
			},
		},
	},
	sales: {
		id: 'sales',
		text: 'Sales',
		path: 'sales',
		icon: 'Store',
		subMenu: {
			dashboard: dashboardPagesMenu.dashboard,
			salesList: {
				id: 'products',
				text: 'Sales List',
				path: 'sales/sales-list',
				icon: 'FactCheck',
			},
			productsGrid: {
				id: 'productsGrid',
				text: 'Products Grid',
				path: 'sales/grid',
				icon: 'CalendarViewMonth',
			},
			productID: {
				id: 'productID',
				text: 'productID',
				path: 'sales/product',
				hide: true,
			},
			product: {
				id: 'product',
				text: 'Product',
				path: 'sales/product/1',
				icon: 'QrCode2',
			},
			transactions: {
				id: 'transactions',
				text: 'Transactions',
				path: 'sales/transactions',
				icon: 'PublishedWithChanges',
			},
		},
	},
	appointment: {
		id: 'appointment',
		text: 'Appointment',
		path: 'appointment',
		icon: 'Today',
		subMenu: {
			dashboard: dashboardPagesMenu.dashboardBooking,
			calendar: {
				id: 'calendar',
				text: 'Calendar',
				path: 'appointment/calendar',
				icon: 'EditCalendar',
				notification: true,
			},
			employeeList: {
				id: 'employeeList',
				text: 'Employee List',
				path: 'appointment/employee-list',
				icon: 'PersonSearch',
			},
			employeeID: {
				id: 'employeeID',
				text: 'employeeID',
				path: 'appointment/employee',
				hide: true,
			},
			employee: {
				id: 'employee',
				text: 'Employee',
				path: 'appointment/employee/1',
				icon: 'QrCode2',
			},
			appointmentList: {
				id: 'appointmentList',
				text: 'Appointment List',
				path: 'appointment/appointment-list',
				icon: 'Event',
			},
		},
	},
	crm: {
		id: 'crm',
		text: 'CRM',
		path: 'crm',
		icon: 'Contacts',
		subMenu: {
			dashboard: {
				id: 'dashboard',
				text: 'CRM Dashboard',
				path: 'crm/dashboard',
				icon: 'RecentActors',
			},
			customersList: {
				id: 'customersList',
				text: 'Customers',
				path: 'crm/customers',
				icon: 'PersonSearch',
			},
			customerID: {
				id: 'customerID',
				text: 'customerID',
				path: 'crm/customer',
				hide: true,
			},
			customer: {
				id: 'customer',
				text: 'Customer',
				path: 'crm/customer/1',
				icon: 'Badge',
			},
			// sales: {
			// 	id: 'sales',
			// 	text: 'Sales',
			// 	path: 'crm/sales',
			// 	icon: 'Storefront',
			// },
			// invoiceID: {
			// 	id: 'invoiceID',
			// 	text: 'invoiceID',
			// 	path: 'crm/invoice',
			// 	hide: true,
			// },
			// invoice: {
			// 	id: 'invoice',
			// 	text: 'Invoice',
			// 	path: 'crm/invoice/1',
			// 	icon: 'Receipt',
			// },
		},
	},
	chat: {
		id: 'chat',
		text: 'Chat',
		path: 'chat',
		icon: 'Forum',
		subMenu: {
			withListChat: {
				id: 'withListChat',
				text: 'With List',
				path: 'chat/with-list',
				icon: 'Quickreply',
			},
			onlyListChat: {
				id: 'onlyListChat',
				text: 'Only List',
				path: 'chat/only-list',
				icon: 'Dns',
			},
		},
	},

	auth: {
		id: 'auth',
		text: 'Auth Pages',
		icon: 'Extension',
	},
	login: {
		id: 'login',
		text: 'Login',
		path: 'auth-pages/login',
		icon: 'Login',
	},
	signUp: {
		id: 'signUp',
		text: 'Sign Up',
		path: 'auth-pages/sign-up',
		icon: 'PersonAdd',
	},
	page404: {
		id: 'Page404',
		text: '404 Page',
		path: 'auth-pages/404',
		icon: 'ReportGmailerrorred',
	},
};

export const pageLayoutTypesPagesMenu = {
	layoutTypes: {
		id: 'layoutTypes',
		text: 'Page Layout Types',
	},
	blank: {
		id: 'blank',
		text: 'Blank',
		path: 'page-layouts/blank',
		icon: 'check_box_outline_blank ',
	},
	pageLayout: {
		id: 'pageLayout',
		text: 'Page Layout',
		path: 'page-layouts',
		icon: 'BackupTable',
		subMenu: {
			headerAndSubheader: {
				id: 'headerAndSubheader',
				text: 'Header & Subheader',
				path: 'page-layouts/header-and-subheader',
				icon: 'ViewAgenda',
			},
			onlyHeader: {
				id: 'onlyHeader',
				text: 'Only Header',
				path: 'page-layouts/only-header',
				icon: 'ViewStream',
			},
			onlySubheader: {
				id: 'onlySubheader',
				text: 'Only Subheader',
				path: 'page-layouts/only-subheader',
				icon: 'ViewStream',
			},
			onlyContent: {
				id: 'onlyContent',
				text: 'Only Content',
				path: 'page-layouts/only-content',
				icon: 'WebAsset',
			},
		},
	},
	asideTypes: {
		id: 'asideTypes',
		text: 'Aside Types',
		path: 'aside-types',
		icon: 'Vertical Split',
		subMenu: {
			defaultAside: {
				id: 'defaultAside',
				text: 'Default Aside',
				path: 'aside-types/default-aside',
				icon: 'ViewQuilt',
			},
			minimizeAside: {
				id: 'minimizeAside',
				text: 'Minimize Aside',
				path: 'aside-types/minimize-aside',
				icon: 'View Compact',
			},
		},
	},
};

export const gettingStartedPagesMenu = {
	gettingStarted: {
		id: 'gettingStarted',
		text: 'Getting Started',
		path: 'getting-started',
		icon: 'Book',
		subMenu: {
			installation: {
				id: 'installation',
				text: 'Installation',
				path: 'getting-started/installation',
				icon: 'BuildCircle',
			},
			dev: {
				id: 'dev',
				text: 'Development',
				path: 'getting-started/development',
				icon: 'DirectionsRun',
			},
			folderStructure: {
				id: 'folderStructure',
				text: 'Folder Structure',
				path: 'getting-started/folder-structure',
				icon: 'SnippetFolder',
			},
			bootstrapVariables: {
				id: 'bootstrapVariables',
				text: 'Bootstrap Variables',
				path: 'getting-started/bootstrap-variables',
				icon: 'SnippetFolder',
			},
			projectStructure: {
				id: 'projectStructure',
				text: 'Project Structure',
				path: 'getting-started/project-structure',
				icon: 'SnippetFolder',
			},
		},
	},
	routes: {
		id: 'routes',
		text: 'Routes & Pages',
		path: 'routes',
		icon: 'AltRoute',
		subMenu: {
			router: {
				id: 'router',
				text: 'Router',
				path: 'routes/router',
				icon: 'Router',
			},
		},
	},
};

export const componentPagesMenu = {
	bootstrap: {
		id: 'bootstrap',
		text: 'Bootstrap',
		icon: 'Extension',
	},
	components: {
		id: 'components',
		text: 'Component',
		path: 'components',
		icon: 'Extension',
		notification: 'success',
		subMenu: {
			accordion: {
				id: 'accordion',
				text: 'Accordion',
				path: 'components/accordion',
				icon: 'ViewDay',
			},
			alert: {
				id: 'alert',
				text: 'Alert',
				path: 'components/alert',
				icon: 'Announcement',
			},
			badge: {
				id: 'badge',
				text: 'Badge',
				path: 'components/badge',
				icon: 'Vibration',
			},
			breadcrumb: {
				id: 'breadcrumb',
				text: 'Breadcrumb',
				path: 'components/breadcrumb',
				icon: 'AddRoad',
			},
			button: {
				id: 'button',
				text: 'Button',
				path: 'components/button',
				icon: 'SmartButton',
			},
			buttonGroup: {
				id: 'buttonGroup',
				text: 'Button Group',
				path: 'components/button-group',
				icon: 'Splitscreen',
			},
			card: {
				id: 'card',
				text: 'Card',
				path: 'components/card',
				icon: 'Crop32',
			},
			carousel: {
				id: 'carousel',
				text: 'Carousel',
				path: 'components/carousel',
				icon: 'RecentActors',
			},
			// Close
			collapse: {
				id: 'collapse',
				text: 'Collapse',
				path: 'components/collapse',
				icon: 'UnfoldLess',
			},
			dropdowns: {
				id: 'dropdowns',
				text: 'Dropdowns',
				path: 'components/dropdowns',
				icon: 'Inventory',
			},
			listGroup: {
				id: 'listGroup',
				text: 'List Group',
				path: 'components/list-group',
				icon: 'ListAlt',
			},
			modal: {
				id: 'modal',
				text: 'Modal',
				path: 'components/modal',
				icon: 'PictureInPicture',
			},
			navsTabs: {
				id: 'navsTabs',
				text: 'Navs & Tabs',
				path: 'components/navs-and-tabs',
				icon: 'PivotTableChart',
			},
			// Navbar
			offcanvas: {
				id: 'offcanvas',
				text: 'Offcanvas',
				path: 'components/offcanvas',
				icon: 'VerticalSplit',
			},
			pagination: {
				id: 'pagination',
				text: 'Pagination',
				path: 'components/pagination',
				icon: 'Money',
			},
			popovers: {
				id: 'popovers',
				text: 'Popovers',
				path: 'components/popovers',
				icon: 'Assistant',
			},
			progress: {
				id: 'progress',
				text: 'Progress',
				path: 'components/progress',
				icon: 'HourglassTop',
			},
			scrollspy: {
				id: 'scrollspy',
				text: 'Scrollspy',
				path: 'components/scrollspy',
				icon: 'KeyboardHide',
			},
			spinners: {
				id: 'spinners',
				text: 'Spinners',
				path: 'components/spinners',
				icon: 'RotateRight',
			},
			table: {
				id: 'table',
				text: 'Table',
				path: 'components/table',
				icon: 'TableChart',
			},
			toasts: {
				id: 'toasts',
				text: 'Toasts',
				path: 'components/toasts',
				icon: 'RotateRight',
			},
			tooltip: {
				id: 'tooltip',
				text: 'Tooltip',
				path: 'components/tooltip',
				icon: 'Assistant',
			},
		},
	},
	forms: {
		id: 'forms',
		text: 'Forms',
		path: 'forms',
		icon: 'CheckBox',
		notification: 'success',
		subMenu: {
			formGroup: {
				id: 'formGroup',
				text: 'Form Group',
				path: 'forms/form-group',
				icon: 'Source',
			},
			formControl: {
				id: 'formControl',
				text: 'Form Controls',
				path: 'forms/form-controls',
				icon: 'Create',
			},
			select: {
				id: 'select',
				text: 'Select',
				path: 'forms/select',
				icon: 'Checklist',
			},
			checksAndRadio: {
				id: 'checksAndRadio',
				text: 'Checks & Radio',
				path: 'forms/checks-and-radio',
				icon: 'CheckBox',
			},
			range: {
				id: 'range',
				text: 'Range',
				path: 'forms/range',
				icon: 'HdrStrong',
			},
			inputGroup: {
				id: 'inputGroup',
				text: 'Input Group',
				path: 'forms/input-group',
				icon: 'PowerInput',
			},
			validation: {
				id: 'validation',
				text: 'Validation',
				path: 'forms/validation',
				icon: 'VerifiedUser',
			},
			wizard: {
				id: 'wizard',
				text: 'Wizard',
				path: 'forms/wizard',
				icon: 'LinearScale',
			},
		},
	},
	content: {
		id: 'content',
		text: 'Content',
		path: 'content',
		icon: 'format_size',
		subMenu: {
			typography: {
				id: 'typography',
				text: 'Typography',
				path: 'content/typography',
				icon: 'text_fields',
			},
			images: {
				id: 'images',
				text: 'Images',
				path: 'content/images',
				icon: 'Image ',
			},
			tables: {
				id: 'tables',
				text: 'Tables',
				path: 'content/tables',
				icon: 'table_chart',
			},
			figures: {
				id: 'figures',
				text: 'Figures',
				path: 'content/figures',
				icon: 'Photo Library ',
			},
		},
	},
	utilities: {
		id: 'utilities',
		text: 'Utilities',
		path: 'utilities',
		icon: 'Support',
		subMenu: {
			api: {
				id: 'api',
				text: 'API',
				path: 'utilities/api',
				icon: 'Api',
			},
			background: {
				id: 'background',
				text: 'Background',
				path: 'utilities/background',
				icon: 'FormatColorFill',
			},
			borders: {
				id: 'borders',
				text: 'Borders',
				path: 'utilities/borders',
				icon: 'BorderStyle',
			},
			colors: {
				id: 'colors',
				text: 'Colors',
				path: 'utilities/colors',
				icon: 'InvertColors',
			},
			display: {
				id: 'display',
				text: 'Display',
				path: 'utilities/display',
				icon: 'LaptopMac',
			},
			flex: {
				id: 'flex',
				text: 'Flex',
				path: 'utilities/flex',
				icon: 'SettingsOverscan',
			},
			float: {
				id: 'float',
				text: 'Float',
				path: 'utilities/float',
				icon: 'ViewArray',
			},
			interactions: {
				id: 'interactions',
				text: 'Interactions',
				path: 'utilities/interactions',
				icon: 'Mouse',
			},
			overflow: {
				id: 'overflow',
				text: 'Overflow',
				path: 'utilities/overflow',
				icon: 'TableRows',
			},
			position: {
				id: 'position',
				text: 'Position',
				path: 'utilities/position',
				icon: 'Adjust',
			},
			shadows: {
				id: 'shadows',
				text: 'Shadows',
				path: 'utilities/shadows',
				icon: 'ContentCopy',
			},
			sizing: {
				id: 'sizing',
				text: 'Sizing',
				path: 'utilities/sizing',
				icon: 'Straighten',
			},
			spacing: {
				id: 'spacing',
				text: 'Spacing',
				path: 'utilities/spacing',
				icon: 'SpaceBar',
			},
			text: {
				id: 'text',
				text: 'Text',
				path: 'utilities/text',
				icon: 'TextFields',
			},
			verticalAlign: {
				id: 'vertical-align',
				text: 'Vertical Align',
				path: 'utilities/vertical-align',
				icon: 'VerticalAlignCenter',
			},
			visibility: {
				id: 'visibility',
				text: 'Visibility',
				path: 'utilities/visibility',
				icon: 'Visibility',
			},
		},
	},
	extra: {
		id: 'extra',
		text: 'Extra Library',
		icon: 'Extension',
		path: undefined,
	},
	icons: {
		id: 'icons',
		text: 'Icons',
		path: 'icons',
		icon: 'Grain',
		notification: 'success',
		subMenu: {
			icon: {
				id: 'icon',
				text: 'Icon',
				path: 'icons/icon',
				icon: 'Lightbulb',
			},
			material: {
				id: 'material',
				text: 'Material',
				path: 'icons/material',
				icon: 'Verified',
			},
		},
	},
	charts: {
		id: 'charts',
		text: 'Charts',
		path: 'charts',
		icon: 'AreaChart',
		notification: 'success',
		subMenu: {
			chartsUsage: {
				id: 'chartsUsage',
				text: 'General Usage',
				path: 'charts/general-usage',
				icon: 'Description',
			},
			chartsSparkline: {
				id: 'chartsSparkline',
				text: 'Sparkline',
				path: 'charts/sparkline',
				icon: 'AddChart',
			},
			chartsLine: {
				id: 'chartsLine',
				text: 'Line',
				path: 'charts/line',
				icon: 'ShowChart',
			},
			chartsArea: {
				id: 'chartsArea',
				text: 'Area',
				path: 'charts/area',
				icon: 'AreaChart',
			},
			chartsColumn: {
				id: 'chartsColumn',
				text: 'Column',
				path: 'charts/column',
				icon: 'BarChart',
			},
			chartsBar: {
				id: 'chartsBar',
				text: 'Bar',
				path: 'charts/bar',
				icon: 'StackedBarChart',
			},
			chartsMixed: {
				id: 'chartsMixed',
				text: 'Mixed',
				path: 'charts/mixed',
				icon: 'MultilineChart',
			},
			chartsTimeline: {
				id: 'chartsTimeline',
				text: 'Timeline',
				path: 'charts/timeline',
				icon: 'WaterfallChart',
			},
			chartsCandleStick: {
				id: 'chartsCandleStick',
				text: 'Candlestick',
				path: 'charts/candlestick',
				icon: 'Cake',
			},
			chartsBoxWhisker: {
				id: 'chartsBoxWhisker',
				text: 'Box Whisker',
				path: 'charts/box-whisker',
				icon: 'SportsMma',
			},
			chartsPieDonut: {
				id: 'chartsPieDonut',
				text: 'Pie & Donut',
				path: 'charts/pie-donut',
				icon: 'PieChart',
			},
			chartsRadar: {
				id: 'chartsRadar',
				text: 'Radar',
				path: 'charts/radar',
				icon: 'BrightnessLow',
			},
			chartsPolar: {
				id: 'chartsPolar',
				text: 'Polar',
				path: 'charts/polar',
				icon: 'TrackChanges',
			},
			chartsRadialBar: {
				id: 'chartsRadialBar',
				text: 'Radial Bar',
				path: 'charts/radial-bar',
				icon: 'DonutLarge',
			},
			chartsBubble: {
				id: 'chartsBubble',
				text: 'Bubble',
				path: 'charts/bubble',
				icon: 'BubbleChart',
			},
			chartsScatter: {
				id: 'chartsScatter',
				text: 'Scatter',
				path: 'charts/scatter',
				icon: 'ScatterPlot',
			},
			chartsHeatMap: {
				id: 'chartsHeatMap',
				text: 'Heat Map',
				path: 'charts/heat-map',
				icon: 'GridOn',
			},
			chartsTreeMap: {
				id: 'chartsTreeMap',
				text: 'Tree Map',
				path: 'charts/tree-map',
				icon: 'AccountTree',
			},
		},
	},
	notification: {
		id: 'notification',
		text: 'Notification',
		path: 'notifications',
		icon: 'NotificationsNone',
	},
	hooks: {
		id: 'hooks',
		text: 'Hooks',
		path: 'hooks',
		icon: 'Anchor',
	},
};

export const productsExampleMenu = {
	companyA: { id: 'companyA', text: 'Company A', path: 'grid-pages/products', subMenu: null },
	companyB: { id: 'companyB', text: 'Company B', path: '/', subMenu: null },
	companyC: { id: 'companyC', text: 'Company C', path: '/', subMenu: null },
	companyD: { id: 'companyD', text: 'Company D', path: '/', subMenu: null },
};

// COMPANY PAGES MENU
/** @userstory US-MENU-01, US-MENU-02, US-MENU-04, US-MENU-05 */
export const companyPagesMenu = {
	dashboard: {
		id: 'company-dashboard',
		text: 'Dashboard',
		path: 'company/dashboard',
		icon: 'Dashboard',
		iconColorClass: 'nav-c-blue',
		subMenu: null,
	},
	Talents: {
		id: 'company-hr',
		text: 'HR',
		path: 'company/hr',
		icon: 'Groups',
		iconColorClass: 'nav-c-amber',
		// notification: false,
		// talentsProfilePath: 'company/talents/:id',
		subMenu: {
			myTalent: {
				id: 'company-my-talent',
				text: 'My Talent',
				path: 'company/my-talent',
				icon: 'Person',
			},
			explore: {
				id: 'company-explore',
				text: 'Searches',
				path: 'company/searches',
				icon: 'Search',
			},
			chat: {
				id: 'company-chat',
				text: 'Chat',
				path: 'company/chat',
				icon: 'Chat',
				featureCode: 'ORGANIZATION_CHAT_MESSAGES', // @userstory US-CPP-CONT-01
			},
			favorites: {
				id: 'company-favorites',
				text: 'Favorites',
				path: 'company/favorites',
				icon: 'Favorite',
			},
			talentCollections: {
				id: 'company-talent-collections',
				text: 'Talent Collections',
				path: 'company/talent-collections',
				icon: 'FolderSpecial',
				detailPath: 'company/talent-collections/:id',
			},
			blacklist: {
				id: 'company-blacklist',
				text: 'Blacklist',
				path: 'company/blacklist',
				icon: 'Block',
				featureCode: 'ORGANIZATION_TRUST_CONTROLS', // @userstory US-C-BL-02
			},
			insights: {
				id: 'company-insights',
				text: 'Insights',
				path: 'company/insights',
				icon: 'Insights',
			},
		},
	},
	FreelanceManagement: {
		id: 'company-freelance-management',
		text: 'company.freelanceManagement.parent',
		path: 'company/quotes',
		icon: 'Gavel',
		iconColorClass: 'nav-c-purple',
		notification: false,
		addOnKey: 'addon.freelance_management',
		subMenu: {
			quotes: {
				id: 'company-fm-quotes',
				text: 'company.freelanceManagement.quotes',
				path: 'company/quotes',
				icon: 'RequestQuote',
			},
			contracts: {
				id: 'company-fm-contracts',
				text: 'company.freelanceManagement.contracts',
				path: 'company/contracts',
				icon: 'Gavel',
			},
			projects: {
				id: 'company-fm-projects',
				text: 'company.freelanceManagement.projects',
				path: 'company/projects',
				icon: 'BusinessCenter',
			},
			milestones: {
				id: 'company-fm-milestones',
				text: 'company.freelanceManagement.milestones',
				path: 'company/milestones',
				icon: 'Flag',
			},
			timesheets: {
				id: 'company-fm-timesheets',
				text: 'company.freelanceManagement.timesheets',
				path: 'company/timesheets',
				icon: 'Schedule',
			},
			invoices: {
				id: 'company-fm-invoices',
				text: 'company.freelanceManagement.invoices',
				path: 'company/invoices',
				icon: 'Receipt',
			},
		},
	},
	Projects: {
		id: 'company-pm',
		text: 'PM',
		path: 'company/projects',
		icon: 'Work',
		iconColorClass: 'nav-c-green',
		hideFromOperationalMenu: true,
		notification: false,
		subMenu: {
			projects: {
				id: 'company-projects',
				text: 'Projects',
				path: 'company/projects',
				icon: 'BusinessCenter',
				//   Projects
				createProjectPath: '/company/projects/create',
				editProjectPath: 'company/projects/edit/:id',
				detailPath: 'company/projects/:id',
				//  Add Internal Member
				addInternalMemberPath:
					'company/projects/:projectId/organizations/:organizationId/add-internal-member',
				//  Assign Project to External
				assignProjectToExternalPath:
					'company/projects/:projectId/organizations/:organizationId/assign-to-external',
				//  Milestones
				milestonesPath:
					'company/projects/:projectId/organizations/:organizationId/milestones',
				createMilestonePath:
					'company/projects/:projectId/organizations/:organizationId/milestones/create',
				milestoneDetailPath:
					'company/projects/:projectId/organizations/:organizationId/milestones/:milestoneId',
				editMilestonePath:
					'company/projects/:projectId/organizations/:organizationId/milestones/:milestoneId/edit',
				//  Timesheets
				timesheetsPath:
					'company/projects/:projectId/organizations/:organizationId/timesheets',
				timesheetDetailPath:
					'company/projects/:projectId/organizations/:organizationId/timesheets/:timesheetId',
				//  Public Project management page
				publicProjectPath: 'company/projects/:id/public',
			},
		},
	},
	// QUOTES section
	Quotes: {
		id: 'company-quotes',
		text: 'Quotes',
		path: 'company/quotes',
		icon: 'RequestQuote',
		iconColorClass: 'nav-c-purple',
		hideFromOperationalMenu: true,
		notification: false,
		subMenu: {
			quoteRequests: {
				id: 'company-quote-requests',
				text: 'Quote Requests',
				path: 'company/quote-requests',
				requestDetailPath: 'company/quotes/requests/:requestId',
				icon: 'RequestQuote',
				featureCode: 'ORGANIZATION_QUOTES', // @userstory US-FG-08
			},
			quotes: {
				id: 'company-received-quotes',
				text: 'Quotes',
				path: 'company/quotes',
				icon: 'Description',
				requestsPath: 'company/quotes/requests',
				detailPath: 'company/quotes/:quoteId',
				featureCode: 'ORGANIZATION_QUOTES', // @userstory US-FG-08
			},
		},
	},
	Finance: {
		id: 'company-finance',
		text: 'Finance',
		path: 'company/invoices',
		icon: 'Receipt',
		iconColorClass: 'nav-c-teal',
		hideFromOperationalMenu: true,
		notification: false,
		subMenu: {
			invoices: {
				id: 'company-invoices',
				text: 'Invoices',
				path: 'company/invoices',
				invoiceDetailPath: 'company/invoices/:invoiceId',
				icon: 'Receipt',
			},
		},
	},
	// SETTINGS (Admin only) - Entry point to settings area
	Settings: {
		id: 'company-settings',
		text: 'Settings',
		path: 'company/settings/organization',
		icon: 'Settings',
		iconColorClass: 'nav-c-gray',
		adminOnly: true,
		subMenu: null,
	},
};

/** @userstory US-MENU-04, US-MENU-05, US-MENU-06 */
// All items are flat direct links (no sub-menus) for streamlined navigation.
// Master Agreement permanently removed — Legal confirmed T&C are sufficient.
// Invoices page removed — subscription page has inline "Invoices" button that opens Stripe portal.
export const settingsMenu = {
	organization: {
		id: 'company-settings-organization',
		text: 'settings.organization',
		path: 'company/settings/organization',
		icon: 'Business',
		iconColorClass: 'nav-c-blue',
		subMenu: null,
	},
	contractTypes: {
		id: 'company-settings-contract-types',
		text: 'settings.contractTypes', // "Contratti" in sidebar
		path: 'company/settings/legal/contract-types',
		icon: 'Description',
		iconColorClass: 'nav-c-purple',
		addOnKey: 'addon.freelance_management',
		subMenu: null,
	},
	team: {
		id: 'company-settings-team',
		text: 'settings.team',
		path: 'company/settings/team',
		icon: 'Groups',
		iconColorClass: 'nav-c-amber',
		subMenu: null,
	},
	subscription: {
		id: 'company-settings-subscription',
		text: 'settings.subscription',
		path: 'company/settings/subscription',
		icon: 'CardMembership',
		iconColorClass: 'nav-c-teal',
		subMenu: null,
	},
};

// Talent SETTINGS MENU - Secondary sidebar for freelance settings area
export const talentSettingsMenu = {
	profile: {
		id: 'talent-settings-profile',
		text: 'Profile',
		path: 'talent/settings/profile',
		icon: 'Person',
		iconColorClass: 'nav-c-blue',
		subMenu: null,
	},
	subscription: {
		id: 'talent-settings-subscription',
		text: 'Subscription',
		path: 'talent/settings/subscription',
		icon: 'CardMembership',
		iconColorClass: 'nav-c-teal',
		subMenu: null,
	},
	billing: {
		id: 'talent-settings-billing',
		text: 'Billing Data',
		path: 'talent/settings/billing',
		icon: 'Receipt',
		iconColorClass: 'nav-c-amber',
		subMenu: null,
	},
};

// US: US-TMENU-01, US-TMENU-02, US-TMENU-03, US-TMENU-04, US-TMENU-05, US-TMENU-06, US-TMENU-07
//  FREELANCE PAGES MENU
// Order: Dashboard, Growth, Network, Messages, Quotes, Projects, Invoices, Settings
export const talentPagesMenu = {
	dashboard: {
		id: 'talent-dashboard',
		text: 'Dashboard',
		path: 'talent/dashboard',
		icon: 'Dashboard',
		iconColorClass: 'nav-c-blue',
		subMenu: null,
	},
	// Growth features live together so they do not interrupt the delivery flow
	Growth: {
		id: 'talent-growth',
		text: 'Growth',
		path: 'talent/opportunity-radar',
		icon: 'Insights',
		iconColorClass: 'nav-c-orange',
		notification: false,
		navigableParent: true,
		subMenu: {
			opportunityRadar: {
				id: 'talent-opportunity-radar',
				text: 'Opportunity Radar',
				path: 'talent/opportunity-radar',
				icon: 'TrackChanges',
				featureCode: 'TALENT_OPPORTUNITY_RADAR_PREVIEW', // @userstory US-TPF-RADR-01
			},
			insights: {
				id: 'talent-insights',
				text: 'Insights',
				path: 'talent/insights',
				icon: 'Insights',
				// @userstory US-TPP-MRKT-01
			},
			referralCredit: {
				id: 'talent-referral-credit',
				text: 'Referral Credit',
				path: 'talent/referral-credit',
				icon: 'Share',
				featureCode: 'TALENT_REFERRALS', // @userstory US-TPF-REF-05
			},
			myPresentations: {
				id: 'talent-my-presentations',
				text: 'My Presentations',
				path: 'talent/growth/my-presentations',
				icon: 'Send',
				featureCode: 'TALENT_OPPORTUNITY_RADAR', // @userstory US-TPF-RADR-03
			},
		},
	},
	// US-TMENU-06: Network — allies and peer discovery grouped in one area
	Alliance: {
		id: 'talent-alliance',
		text: 'Network',
		path: 'talent/alliance',
		icon: 'GroupWork',
		iconColorClass: 'nav-c-rose',
		notification: false,
		navigableParent: true,
		subMenu: {
			overview: {
				id: 'talent-alliance-overview',
				text: 'Overview',
				path: 'talent/alliance',
				icon: 'Dashboard',
			},
			myAllies: {
				id: 'talent-my-allies',
				text: 'My Allies',
				path: 'talent/alliance/allies',
				icon: 'People',
			},
			dreamTeam: {
				id: 'talent-dream-team',
				text: 'Dream Team',
				path: 'talent/alliance/dream-team',
				icon: 'EmojiEvents',
			},
			findTalents: {
				id: 'talent-peer-search',
				text: 'Find Talents',
				path: 'talent/peer-search',
				icon: 'PersonSearch',
				featureCode: 'TALENT_PEER_SEARCHES', // @userstory US-TPF-SRCH-01
			},
		},
	},
	// US-TMENU-02: Messages — inbox and chats grouped in one communication area
	Messages: {
		id: 'talent-messages',
		text: 'Messages',
		path: 'talent/chat',
		icon: 'Email',
		iconColorClass: 'nav-c-cyan',
		notification: false,
		navigableParent: true,
		subMenu: {
			companyChat: {
				id: 'talent-chat',
					text: 'Companies',
				path: 'talent/chat',
				icon: 'Chat',
				featureCode: 'TALENT_STAKEHOLDER_MESSAGES', // @userstory US-TPP-MSG-01
			},
			peerChat: {
				id: 'talent-peer-chat',
					text: 'Talents',
				path: 'talent/peer-chat',
				icon: 'Forum',
				featureCode: 'TALENT_PEER_SEARCHES', // @userstory US-T2T-CHAT-01
			},
		},
	},
	FreelanceManagement: {
		id: 'talent-freelance-management',
		text: 'talent.freelanceManagement.parent',
		path: 'talent/quotes/requests',
		icon: 'Gavel',
		iconColorClass: 'nav-c-purple',
		notification: false,
		subMenu: {
			quotes: {
				id: 'talent-fm-quotes',
				text: 'talent.freelanceManagement.quotes',
				path: 'talent/quotes/requests',
				icon: 'RequestQuote',
				featureCode: 'TALENT_QUOTES',
			},
			contracts: {
				id: 'talent-fm-contracts',
				text: 'talent.freelanceManagement.contracts',
				path: 'talent/contracts',
				icon: 'Gavel',
			},
			projects: {
				id: 'talent-fm-projects',
				text: 'talent.freelanceManagement.projects',
				path: 'talent/projects',
				icon: 'BusinessCenter',
			},
			milestones: {
				id: 'talent-fm-milestones',
				text: 'talent.freelanceManagement.milestones',
				path: 'talent/milestones',
				icon: 'Flag',
			},
			timesheets: {
				id: 'talent-fm-timesheets',
				text: 'talent.freelanceManagement.timesheets',
				path: 'talent/timesheets',
				icon: 'Schedule',
			},
			invoices: {
				id: 'talent-fm-invoices',
				text: 'talent.freelanceManagement.invoices',
				path: 'talent/invoices',
				icon: 'Receipt',
			},
		},
	},
	// US-TMENU-03: Quotes — groups the commercial lifecycle (requests + sent quotes)
	Quotes: {
		id: 'talent-quotes',
		text: 'Quotes',
		path: 'talent/quotes/requests',
		icon: 'RequestQuote',
		iconColorClass: 'nav-c-purple',
		hideFromOperationalMenu: true,
		notification: false,
		subMenu: {
			quoteRequests: {
				id: 'talent-quote-requests',
				text: 'Quote Requests',
				path: 'talent/quotes/requests',
				icon: 'Inbox',
				featureCode: 'TALENT_QUOTES', // @userstory US-FG-13
			},
			sentQuotes: {
				id: 'talent-sent-quotes',
				text: 'My Quotes',
				path: 'talent/quotes/my-quotes',
				icon: 'RequestQuote',
				featureCode: 'TALENT_QUOTES', // @userstory US-FG-13
			},
		},
		// Paths for routing (kept for compatibility)
		requestsPath: 'talent/quotes/requests',
		requestDetailPath: 'talent/quotes/requests/:requestId',
		detailPath: 'talent/quotes/:quoteId',
		createPath: 'talent/quotes/create/:quoteRequestId',
		editPath: 'talent/quotes/edit/:quoteId',
	},
	// US-TMENU-04: Projects — dropdown with Assigned + Public sub-items
	Projects: {
		id: 'talent-projects',
		text: 'Projects',
		path: 'talent/projects',
		icon: 'Work',
		iconColorClass: 'nav-c-green',
		hideFromOperationalMenu: true,
		notification: false,
		subMenu: {
			publicProjects: {
				id: 'talent-projects-public',
				text: 'projects.public',
				path: 'talent/project-board',
				icon: 'Assignment',
			},
			myExpressions: {
				id: 'talent-my-expressions',
				text: 'projects.myExpressions',
				path: 'talent/project-board/my-expressions',
				icon: 'FavoriteBorder',
			},
			assigned: {
				id: 'talent-projects-assigned',
				text: 'projects.assigned',
				path: 'talent/projects',
				icon: 'BusinessCenter',
			},
		},
		// Assigned project paths
		projectDetailPath: 'talent/projects/:projectId/organizations/:organizationId',
		milestonesPath: 'talent/projects/:projectId/organizations/:organizationId/milestones',
		milestoneDetailPath:
			'talent/projects/:projectId/organizations/:organizationId/milestones/:milestoneId',
		timesheetsPath: 'talent/projects/:projectId/organizations/:organizationId/timesheets',
		timesheetDetailPath:
			'talent/projects/:projectId/organizations/:organizationId/timesheets/:timesheetId',
		createTimesheetPath:
			'talent/projects/:projectId/organizations/:organizationId/timesheets/create',
		updateTimesheetPath:
			'talent/projects/:projectId/organizations/:organizationId/timesheets/:timesheetId/edit',
		// Public project paths (Project Board) — US-PP-13
		publicProjectDetailPath: 'talent/project-board/:id',
		myExpressionsPath: 'talent/project-board/my-expressions',
	},
	// US-TMENU-05: Invoices — standalone (no submenu wrapper)
	Invoices: {
		id: 'talent-invoices',
		text: 'Invoices',
		path: 'talent/invoices',
		icon: 'Receipt',
		iconColorClass: 'nav-c-teal',
		hideFromOperationalMenu: true,
		notification: false,
		subMenu: null,
		invoiceDetailPath: 'talent/invoices/:invoiceId',
	},
	// US-TMENU-07: Settings — entry point to settings area
	Settings: {
		id: 'talent-settings',
		text: 'Settings',
		path: 'talent/settings/profile',
		icon: 'Settings',
		iconColorClass: 'nav-c-gray',
		notification: false,
		subMenu: null,
	},
};
